import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { instance } from '@app/api/axios';
import { showToaster } from '@shared/ui/messages/useToaster';
import i18n from '@app/i18n';

export const fetchTariff = createAsyncThunk(
  'tariff/fetchTariff',
  async (_, { rejectWithValue }) => {
    try {
      const res = await instance.get('/my_team/tariff');
      return res.data?.team_tariff_settings;
    } catch (err) {
      showToaster(
        'error',
        err?.response?.data?.message || i18n.t('request_error'),
      );
      return rejectWithValue(err.message);
    }
  },
);

const tariffSlice = createSlice({
  name: 'tariff',
  initialState: {
    tariff: {},
  },
  extraReducers: (builder) => {
    builder.addCase(fetchTariff.fulfilled, (state, action) => {
      state.tariff = action.payload?.tariff || action.payload || {};
    });
  },
});

export default tariffSlice.reducer;
